import { render, staticRenderFns } from "./DomainBulkStatusEdit.vue?vue&type=template&id=efaa6c50"
import script from "./DomainBulkStatusEdit.vue?vue&type=script&lang=js"
export * from "./DomainBulkStatusEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports